import productPageContent from '~/apollo/queries/product/common/productPageContent';
import processQuerystring from '~/mixins/processQuerystring.js';

export default {
  mixins: [processQuerystring],
  apollo: {
    productPageContent: {
      query: productPageContent,
      prefetch: true,
      variables() {
        return {
          category: this.category,
          currentlocale: this.$normalizeLocale(this.$i18n.locale),
        };
      },
      update(data) {
        return this.$normalizeStrapi(data.productsPage.data);
      },
    },
  },

  data() {
    return {
      category: '',
    };
  },

  head() {
    return {
      title: this.metaData?.Title,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.metaData?.Title,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.metaData?.Description,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.metaData?.Description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: this.metaData?.Image?.url,
        },
      ],
    };
  },

  computed: {
    displayProductsLength() {
      return this.displayProducts?.length;
    },
    sectionHeaderStaticData() {
      return this.productPageContent?.PageContentByCategory[0]?.SectionHeader;
    },
    metaData() {
      return this.productPageContent?.PageContentByCategory[0]?.MetaData;
    },
    assumptionTooltipHtml() {
      return this.getTooltipContentByKey('assumption');
    },
    filterSum() {
      const filterSum = [];
      const filterListKey = Object.keys(this.filter).filter(key => key.includes('Value'));
      filterListKey.forEach(key => {
        // check has insurer filter
        if (Array.isArray(this.filter[key])) {
          if (this.filter[key].length > 0) {
           filterSum.push(this.filter[key]);
           return;
          }
        } else {
          //check has other filter
          if (Array.isArray(this.filter[key].value)) {
            if (this.filter[key].value[1] != 0) {
              filterSum.push(this.filter[key]);
            }
          } else {
            if (this.filter[key].value != '' && this.filter[key].value != '-1') {
              filterSum.push(this.filter[key]);
            }
          }
          // if (this.filter[key].value.length > 1) {
          //   if (this.filter[key].value[1] != 0) {
          //     filterSum.push(this.filter[key]);
          //     return;
          //   }
          // }
          // if (this.filter[key].value != '-1') {
          //   filterSum.push(this.filter[key]);
          //   return;
          // }
        }

      })
      return filterSum.length;
    },
  },

  watch: {
    category: {
      handler(newVal) {
        this.refreshProductsComparison(newVal);
      },
      immediate: true,
    },

    displayProductsLength() {
      this.refreshProductsComparison(this.category);
    },

    $route: {
      handler() {
        const lastPathSegment = /[^/]*$/.exec(this.$route.path)[0];
        const queryStringCheck =
          lastPathSegment === 'medical' && (this.$route.query.vhistype === '44' || this.$route.query.vhistype === '45');

        const qdapQueryStringCheck =
          lastPathSegment === 'deferred-annuity' &&
          (this.$route.query.objective === 'saving' ||
            this.$route.query.objective === 'stable_retirement_income' ||
            this.$route.query.objective === 'growth_retirement_income' ||
            this.$route.query.objective === 'longevity');
        const pathMatch = queryStringCheck ? /[^/]*\/?\?/.exec(this.$route.fullPath) : /[^/]*$/.exec(this.$route.path);
        let category = pathMatch ? pathMatch[0].replace(/[/?]/g, '') : '';

        if (queryStringCheck) {
          category += '?vhistype';
        }

        if (qdapQueryStringCheck) {
          if (this.$route.query.objective === 'stable_retirement_income') {
            category += '/stable_retirement_income';
          }
          if (this.$route.query.objective === 'growth_retirement_income') {
            category += '/growth_retirement_income';
          }
          if (this.$route.query.objective === 'longevity') {
            category += '/longevity';
          }
        }
        if (category === 'deferred-annuity') {
          category += '/savings';
        }

        this.category = category;
      },
      immediate: true,
    },
  },

  mounted() {
    this.openDisclaimerModal();
  },

  methods: {
    openDisclaimerModal() {
      if (this.$store.state.disclaimerPopup.hasProductDisclaimerConfirmed) return;

      this.$store.commit('modal/setShowProductDisclaimerModal', true);
    },

    processFilterText(value, options) {
      value.text = options?.find((option) => this.$_.isEqual(option.value, value.value))?.text;
    },

    locateFilterOption(value, options) {
      return options?.find((option) => this.$_.isEqual(option.value, value));
    },

    fixFilterValues(filterValues) {
      filterValues.forEach((fv) => {
        if (fv.ignoreFix) return;
        this.fixFilterValue(fv);
      });
    },

    fixFilterValue(fv) {
      // console.debug('fixFilterValue...!')
      // console.debug(fv);
      const options = this.$_.get(this, fv.filterOptionsPath);
      const actualValue = this.$_.get(this, fv.filterValuePath + '.value');
      const foundOption = this.locateFilterOption(actualValue, options);
      // console.debug(options);
      // console.debug(actualValue);
      // console.debug(foundOption)
      if (foundOption) {
        this.$_.set(this, fv.filterValuePath, this.locateFilterOption(actualValue, options));
      } else {
        this.$_.set(this, fv.filterValuePath, this.locateFilterOption(fv.defaultValue, options));
      }
    },


    fixFilterArrayValueDueToQueryString(fv) {
      if (this.$route.query[fv.queryKey]) {
        if (fv.queryKey === 'date_period[]') {
          // console.log('found')
          // console.log(this.$route.query[fv.queryKey], 'fixFilterArrayValueDueToQueryString')
          this.$_.set(this, fv.filterValuePath, this.$route.query[fv.queryKey]);
          return;
        }
        const options = this.$_.get(this, fv.filterOptionsPath);
        // console.log(options, 'options');
        if (fv.queryKey === 'geo[]') {

          //specail case for geo[] = 0
          if ((this.$route.query[fv.queryKey].includes('0') || this.$route.query[fv.queryKey] === '0')) {
            // console.log(this.$route.query[fv.queryKey], 'this.$route.query[fv.queryKey]')
            this.$_.set(this, fv.filterValuePath, []);
            return;
          }
          const foundValues = options
            .filter((element) => {
              if (typeof this.$route.query[fv.queryKey] === 'string') {
                return (
                  this.$route.query[fv.queryKey].includes(element.value) &&
                  this.$route.query[fv.queryKey].length === element.value.length
                );
              } else {
                return this.$route.query[fv.queryKey].includes(element.value);
              }
            })
            .map((x) => ({
              value: x.value,
              text: x.text,
              continent: x.continent,
            }));
          // console.log(foundValues, 'foundvalues');
          this.$_.set(this, fv.filterValuePath, foundValues);
        } else {
          const foundValues = options
            .filter((element) => {
              if (typeof this.$route.query[fv.queryKey] === 'string') {
                return (
                  this.$route.query[fv.queryKey].includes(element.value) &&
                  this.$route.query[fv.queryKey].length === element.value.length
                );
              } else {
                return this.$route.query[fv.queryKey].includes(element.value);
              }
            })
            .map((x) => ({
              value: x.value,
              text: x.text,
            }));
          // console.log(foundValues, 'foundvalues');
          this.$_.set(this, fv.filterValuePath, foundValues);
        }
      }
    },

    refreshProductsComparison(mCategory) {
      const params = {
        category: mCategory,
        products: this.displayProducts?.map((p) => ({
          id: p.id,
          productName: p.productName,
          insurnanceName: p.insuranceCompany.name,
          logoSrc: p.insuranceCompany.logoSrc,
          logoAlt: p.insuranceCompany.logoAlt,
          link: p.productLink,
        })),
      };
      this.$store.commit('productCompare/refreshProducts', params);
    },

    createFilterWatchers(filterValues) {
      filterValues.forEach((fv) => {
        this.createFilterValueWatcher(fv);
        this.createQueryStringWatcher(fv);
      });
    },

    createFilterValueWatcher(fv) {
      this.$watch(
        function () {
          return this.$_.get(this, fv.filterValuePath);
        },
        (newValue, oldValue) => {
          switch (fv.type) {
            case 'array': {
              // console.log('createFilterValueWatcher!!! ** array')
              // console.log('fv: ', fv)
              // console.log('newValue: ', newValue)
              // console.log('oldValue: ', oldValue)
              if (this.$_.isEqual(newValue, oldValue)) return;
              if (newValue === undefined || newValue?.length === 0) {

                // specail case for geo[] = 0
                if (fv.queryKey === 'geo[]') {
                  this.extendQueryString({ [fv.queryKey]: '0' });
                  break;
                }
                this.removeSingleQueryString(fv.queryKey);
              } else {
                this.extendQueryString({ [fv.queryKey]: newValue?.map((element) => element.value).sort() });
              }
              break;
            }
            case 'arrayDate': {
              // console.debug('createFilterValueWatcher!!! ** array')
              // console.debug(fv)
              // console.debug(newValue)
              // console.debug(oldValue)
              // console.log(fv)
              // console.log(newValue, 'new')
              // console.log(oldValue)
              if (this.$_.isEqual(newValue, oldValue)) return;
              if (newValue === undefined || newValue?.length === 0) {
                // console.log('remove query')
                this.removeSingleQueryString(fv.queryKey);
              } else {
                // console.log('extend query')
                this.extendQueryString({ [fv.queryKey]: newValue?.map((element) => element) });
              }
              break;
            }

            case 'slider': {
              // console.debug('createFilterValueWatcher!!! ** slider')
              // console.debug(fv)
              // console.debug(newValue)
              // console.debug(oldValue)
              if (newValue === oldValue) return;
              if (newValue === fv.defaultValue) {
                // console.debug('remove')
                this.removeSingleQueryString(fv.queryKey);
              } else {
                // console.debug('extend')
                this.extendQueryString({ [fv.queryKey]: newValue });
              }
              break;
            }

            case 'input': {
              if (newValue === oldValue) return;
              if (newValue === fv.defaultValue) {
                this.removeSingleQueryString(fv.queryKey);
              } else {
                this.extendQueryString({ [fv.queryKey]: newValue });
              }
              break;
            }
            case 'checkbox': {
              if (newValue === oldValue) return;
              if (newValue === fv.defaultValue) {
                this.removeSingleQueryString(fv.queryKey);
              } else {
                this.extendQueryString({ [fv.queryKey]: newValue });
              }
              break;
            }

            default: {
              // console.debug('createFilterValueWatcher!!!');
              // console.debug(fv)
              // console.debug(newValue?.value)
              // console.debug(oldValue?.value)
              if (newValue?.value === oldValue?.value) return;
              if (newValue?.value === fv.defaultValue) {
                // console.debug('remove')
                this.removeSingleQueryString(fv.queryKey);
              } else {
                // console.debug('extend')
                this.extendQueryString({ [fv.queryKey]: newValue?.value });
              }
            }
          }
        },
        {
          deep: fv.type === 'array',
        }
      );
    },

    createQueryStringWatcher(fv) {
      const watcherExpression = (type, queryKey) => {
        if (type === 'array') {
          return function () {
            return this.$route.query[queryKey];
          };
        }
        if (type === 'arrayDate') {
          return function () {
            return this.$route.query[queryKey];
          };
        }
        return '$route.query.' + queryKey;
      };

      this.$watch(watcherExpression(fv.type, fv.queryKey), (newValue) => {
        switch (fv.type) {
          case 'array': {
            const mValue = newValue === undefined || newValue?.length === 0 ? [] : newValue;
            const options = this.$_.get(this, fv.filterOptionsPath);
            const foundValues = mValue
              ? options
                  .filter((ins) => mValue.includes(ins.value))
                  .map((x) => ({
                    value: x.value,
                    text: x.text,
                    continent: x?.continent,
                  }))
              : [];
            this.$_.set(this, fv.filterValuePath, foundValues);
            break;
          }
          case 'arrayDate': {
            const mValue = newValue === undefined || newValue?.length === 0 ? [] : newValue;
            this.$_.set(this, fv.filterValuePath, mValue);
            break;
          }

          case 'slider': {
            const regExp = /\[(\d+)\]$/g;
            const mValue = newValue === undefined || newValue === null ? fv.defaultValue : parseInt(newValue);
            const valuePath = fv.filterValuePath.replace(regExp, '');
            const captureText = regExp.exec(fv.filterValuePath);
            if (captureText === null || captureText === undefined) break;
            const valueIndex = captureText[1];
            const valueLocation = this.$_.get(this, valuePath);
            this.$set(valueLocation, valueIndex, mValue);
            break;
          }

          case 'input': {
            const mValue = newValue === undefined || newValue === null ? fv.defaultValue : newValue;
            this.$_.set(this, fv.filterValuePath, mValue);
            break;
          }
          case 'checkbox': {
            const mValue = newValue === undefined || newValue === null ? fv.defaultValue : newValue;
            let tmpValue;
            if (mValue === 'true' || mValue === true) {
              tmpValue = true;
            } else {
              tmpValue = false;
            }
            this.$_.set(this, fv.filterValuePath, tmpValue);
            break;
          }

          default: {
            const mValue = newValue === undefined || newValue === null ? fv.defaultValue : newValue;
            const options = this.$_.get(this, fv.filterOptionsPath);
            const foundOption = this.locateFilterOption(mValue, options);
            if (foundOption) {
              this.$_.set(this, fv.filterValuePath, this.locateFilterOption(mValue, options));
            } else {
              this.$_.set(this, fv.filterValuePath, this.locateFilterOption(fv.defaultValue, options));
            }
          }
        }
      });
    },
  },
};
